import { ToastController, NavController } from '@ionic/angular';
import { Component, OnInit, Input } from '@angular/core';

import { Router } from '@angular/router';
import { SupportService } from 'src/app/services/support/support.service';
import { SosService } from 'src/app/services/sos/sos.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  // tslint:disable-next-line:no-input-rename
  @Input('menu') menu: any;
  // tslint:disable-next-line:no-input-rename
  @Input('classI') classI: any;

  constructor(
    private toastCtrl: ToastController,
    private navCtrl: NavController,
    private router: Router,
    public supportServ: SupportService,
    public sosServ: SosService
    ) { }

  ngOnInit() {
  }

  async buyItem(menu) {
    const toast = await this.toastCtrl.create({
      message: `Added to cart: ${menu.name}`,
      duration: 2000
    });
    toast.present();
  }

  openMenu(menu) {
    this.navCtrl.navigateRoot(menu.url);
    // this.router.navigateByUrl(menu.url);
  //  // console.log(menu);
  }
}
